import * as React from "react";
const SvgHeadset = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.66 15.617c.352 0 .638.286.638.638v2.553A3.19 3.19 0 0 1 18.106 22h-4.255a.638.638 0 1 1 0-1.277h4.255a1.915 1.915 0 0 0 1.915-1.915v-2.553c0-.352.286-.638.639-.638M3 12c0-.352.286-.638.638-.638h4.256c.352 0 .638.286.638.638v5.957a.64.64 0 0 1-.638.639H5.34A2.34 2.34 0 0 1 3 16.256zm1.277.638v3.617c0 .588.476 1.064 1.063 1.064h1.915v-4.68z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.766 12c0-.352.286-.638.638-.638h4.256c.352 0 .638.286.638.638v4.255a2.34 2.34 0 0 1-2.34 2.34h-2.554a.64.64 0 0 1-.638-.638zm1.277.638v4.681h1.914c.588 0 1.064-.476 1.064-1.064v-3.617z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 11.149A9.15 9.15 0 0 1 12.149 2a9.15 9.15 0 0 1 9.149 9.149V12a.638.638 0 0 1-1.277 0v-.851a7.872 7.872 0 1 0-15.744 0V12A.638.638 0 0 1 3 12z",
    clipRule: "evenodd"
  }
));
export default SvgHeadset;
